import { ReInvestTypes } from '../components/dashboard/commercial/ExploreMFs/types';

export type subPlanType = {
    subplanFullName: string;
    subplanDescription: string;
    subplanIsin: string;
};
type useIdcwPropType = {
    subPlans: Array<subPlanType>;
};
type idcwOptionType = {
    isin: string;
    optionValue: string;
    optionName: string;
};
export type useIdcwReturnType = Array<idcwOptionType>;

export const useIdcw = ({ subPlans }: useIdcwPropType): useIdcwReturnType => {
    let idcwOptions: useIdcwReturnType = [];
    subPlans.forEach(({ subplanDescription, subplanIsin }: subPlanType) => {
        if (subplanDescription.toUpperCase().includes('REINVEST')) {
            idcwOptions.push({
                isin: subplanIsin,
                optionValue: ReInvestTypes.ReInvestment,
                optionName: 'Re-Investment',
            });
        } else {
            idcwOptions.push({
                isin: subplanIsin,
                optionValue: ReInvestTypes.Payout,
                optionName: 'Payout',
            });
        }
    });
    return idcwOptions;
};
